import { render, staticRenderFns } from "./AgingReport.vue?vue&type=template&id=27fff9b5&"
import script from "./AgingReport.vue?vue&type=script&lang=js&"
export * from "./AgingReport.vue?vue&type=script&lang=js&"
import style0 from "./AgingReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports